import globals from "../globals";
import Storage from "./storage";

const APIAMIGO = globals.REACT_APP_APIAMIGO;
const ENDERECO = globals.REACT_APP_ENDERECO;
const API_TIME_DE_CRAQUE = globals.REACT_APP_COPA_API;

console.log("API_TIME_DE_CRAQUE", API_TIME_DE_CRAQUE);

function getToken() {
  let userCredencial = Storage.get("TOKEN");
  return userCredencial;
}

const ApiServices = {
  apiLoginTimeDeCraque: (parameter = undefined, obj = undefined) => {
    if (parameter) {
      return fetch(`${API_TIME_DE_CRAQUE}${parameter}`, {
        method: "GET",
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify(obj),
      }).then((res) => res.json());
    }
  },
  apiGetTimeDeCraque: (
    parameter = undefined, 
    token = undefined
  ) => {
    if (parameter) {
      return fetch(`${API_TIME_DE_CRAQUE}${parameter}`, {
        method: "GET",
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${token}`,
        }, 
      }).then((res) => res.json());
    }
  },
  apiLoginBase: (parameter = undefined, obj = undefined) => {
    if (parameter) {
      if (
        parameter === "login/external" &&
        (typeof obj !== "string" || obj.trim() === "")
      ) {
        return Promise.resolve({
          statusCode: 400,
          message: "Token de acesso externo não informado.",
        });
      }

      return fetch(`${APIAMIGO}${parameter}`, {
        method: "POST",
        headers: {
          "Content-Type": "text/plain",
          Accept: "*/*",
        },
        body: obj,
      }).then((res) => res.json());
    } else {
    }
  },
  apiPostTokenBearer: (parameter = undefined, obj = undefined) => {
    if (parameter) {
      return fetch(`${APIAMIGO}${parameter}`, {
        method: "POST",
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify(obj),
      }).then((res) => res.json());
    }
  },

  apiGetTokenBearer: (parameter = undefined, obj = undefined) => {
    if (parameter) {
      return fetch(`${APIAMIGO}${parameter}`, {
        method: "GET",
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify(obj),
      }).then((res) => res.json());
    }
  },

  apiLogin: (parameter = undefined, obj = undefined) => {
    if (parameter) {
      return fetch(`${APIAMIGO}${parameter}`, {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify(obj),
      }).then((res) => res.json());
    } else {
    }
  },

  apiGetWithToken: (parameter = undefined, token = undefined) => {
    if (parameter && token) {
      return fetch(`${APIAMIGO}${parameter}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }).then((res) => res.json());
    } else {
    }
  },

  apiGet: (parameter = undefined) => {
    if (parameter) {
      //alert('sem captcha');
      return fetch(`${APIAMIGO}${parameter}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }).then((res) => res.json());
    } else {
    }
  },
  apiGetRegulamento: (parameter = undefined) => {
    if (parameter) {
      //alert('sem captcha');
      return fetch(`${APIAMIGO}${parameter}`, {
        method: "GET",
        headers: {
          Accept: "text/plain",
          Authorization: `Bearer ${getToken()}`,
        },
      }).then((res) => res.json());
    } else {
    }
  },

  apiPostResgate: (parameter = undefined, obj = undefined) => {
    if (parameter) {
      return fetch(`${APIAMIGO}${parameter}`, {
        method: "POST",
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify(obj),
      });
    } else {
    }
  },

  apiPost: (parameter = undefined, obj = undefined) => {
    if (parameter) {
      return fetch(`${APIAMIGO}${parameter}`, {
        method: "POST",
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify(obj),
      }).then((res) => res.json());
    } else {
    }
  },
  apiGetEndereco: (parameter = undefined) => {
    if (parameter) {
      //alert('sem captcha');
      return fetch(`${ENDERECO}${parameter}`, {
        method: "GET",
      }).then((res) => res.json());
    } else {
    }
  },
  apiPut: (parameter = undefined, obj = undefined) => {
    if (parameter) {
      return fetch(`${APIAMIGO}${parameter}`, {
        method: "PUT",
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify(obj),
      }).then((res) => res.json());
    } else {
    }
  },
  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////

  apiPostWithToken: (parameter = undefined, obj = undefined) => {
    if (parameter) {
      var captcha = Storage.get("captcha");
      if (captcha == undefined || captcha == "") {
        return fetch(`${APIAMIGO}${parameter}`, {
          method: "POST",
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${getToken()}`,
          },
          body: JSON.stringify(obj),
        }).then((res) => res.json());
      } else {
        return fetch(`${APIAMIGO}${parameter}`, {
          method: "POST",
          headers: {
            "content-type": "application/json",
            captcha: captcha,
            Authorization: `Bearer ${getToken()}`,
            //'key':RECAPTCHAKEY
          },
          body: JSON.stringify(obj),
        }).then((res) => res.json());
      }
    } else {
    }
  },

  apiPostWithTokenNotaFiscal: (
    parameter = undefined,
    page = 1,
    per_page = 5,
    pesquisa = ""
  ) => {
    if (parameter) {
      var captcha = Storage.get("captcha");
      return fetch(`${APIAMIGO}${parameter}`, {
        method: "POST",
        headers: {
          "content-type": "application/json",
          captcha: captcha,
          Authorization: `Bearer ${getToken()}`,
          //'key':RECAPTCHAKEY
        },
        body: JSON.stringify({
          page: page,
          per_page: per_page,
          pesquisa: pesquisa,
        }),
      }).then((res) => res.json());
    }
  },

  apiUpload: (parameter = undefined, obj = undefined) => {
    if (parameter) {
      return fetch(`${APIAMIGO}${parameter}`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${getToken()}`,
          Accept: "multipart/form-data",
        },
        body: obj,
      }).then((res) => res.json());
    } else {
    }
  },

  apiPatch: (parameter = undefined, obj = undefined) => {
    if (parameter) {
      return fetch(`${APIAMIGO}${parameter}`, {
        method: "PATCH",
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify(obj),
      }).then((res) => res.json());
    } else {
    }
  },

  apiPutReturnJson: (parameter = undefined, obj = undefined) => {
    if (parameter) {
      return fetch(`${APIAMIGO}${parameter}`, {
        method: "PUT",
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify(obj),
      }).then((res) => res.json());
    } else {
    }
  },

  apiDel: (parameter = undefined) => {
    if (parameter) {
      return fetch(`${APIAMIGO}${parameter}`, {
        method: "DELETE",
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      }).then((res) => res);
    } else {
    }
  },

  apiPostWithTokenPremiacao: (
    parameter = undefined,
    page = 1,
    per_page = 5,
    pesquisa = ""
  ) => {
    if (parameter) {
      var captcha = Storage.get("captcha");
      return fetch(`${APIAMIGO}${parameter}`, {
        method: "POST",
        headers: {
          "content-type": "application/json",
          captcha: captcha,
          Authorization: `Bearer ${getToken()}`,
          //'key':RECAPTCHAKEY
        },
        body: JSON.stringify({
          page: page,
          per_page: per_page,
          pesquisa: pesquisa,
        }),
      }).then((res) => res.json());
    }
  },

  apiGetWithIdAndToken: (parameter = undefined, id = undefined) => {
    if (parameter) {
      return fetch(`${APIAMIGO}${parameter}/${id}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }).then((res) => res.json());
    } else {
    }
  },
};

export default ApiServices;
